import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ScoreNumerator = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${28 * Screen.widthRatio}px;
  margin-left: ${12 * Screen.widthRatio}px;
`;

export default ScoreNumerator;
